import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

import { IonicAngularProvider } from '../../providers/ionic-angular/ionic-angular';

import * as _ from 'lodash';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

	
  constructor(
	public router: Router,
	public IA: IonicAngularProvider,
	) { 
	 
	}

  ngOnInit() {
  }

  
  

      

}



// WEBPACK FOOTER //
// C:/projects/angular/DineroAgil/src/app/pages/home/home.component.ts